import React, { Component } from "react"
import "./InformativeModal.css"
import img1 from "./banner/b1.png"
import insActive from "./img/instruction-active.png"
import insNonActive from "./img/instruction-non-active.png"
import jsondata from "./../../assets/elements.json";
import typeTranslations from "../../assets/creator/typeTranslations.json";
import { getCurrentLang, getCurrentLangFullName, getTranslation } from "../../assets/creator/translations";

class InformativeModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showFirstCloud: true,
			showSecondCloud: false,
			showThirdCloud: false,
			isSmallScrren: false,
			currentLang: getCurrentLang(),
			langList: ["Polski", "English", "Deutsch", "Français"],
			currentLangFullName: getCurrentLangFullName()
		}
	}

	handleCloseBtn = () => {
		this.setState({ showFirstCloud: true, showSecondCloud: false, showThirdCloud: false });
		this.props.handleClose();
	}

	handleResize = () => {
		if (window.innerWidth < 1692) {
			this.setState({ isSmallScrren: true });
		} else {
			this.setState({ isSmallScrren: false });
		}
	}

	informativeModalLeftSideClassGenerator = () => {
		const baseClass = 'informative-modal_left-side';
		if (!this.state.showFirstCloud) {
			return `${baseClass} informative-modal_left-side--hide`;
		}
		return baseClass;
	};
	
	informativeModalFirstCloudClassGenerator = () => {
		const baseClass = 'informative-modal__cloud informative-modal__cloudFirst';
		if (this.state.isSmallScrren) {
			return `${baseClass} informative-modal__cloudFirst--small-screen`;
		}
		return baseClass;
	};

	informativeModalSecondImgCloudClassGenerator = () => {
		const baseClass = 'imgCloudSecond';
		if (!this.state.showSecondCloud) {
			return `${baseClass} imgCloudSecond--hide`;
		}
		return baseClass;
	};	

	componentDidMount = () => {
		this.handleResize();
		window.addEventListener('resize', this.handleResize);
	}

	componentDidUpdate = (prevProps) => {
		if (prevProps.currentLang !== this.props.currentLang) {
			let currentLangName = '';
			if (this.props.currentLang === 'pl') {
				currentLangName = this.state.langList[0];
			} else if (this.props.currentLang === 'en') {
				currentLangName = this.state.langList[1];
			} else if (this.props.currentLang === 'de') {
				currentLangName = this.state.langList[2];
			} else if (this.props.currentLang === 'fr') {
				currentLangName = this.state.langList[3];
			} else {
				currentLangName = this.state.langList[0];
			}
			this.setState({ currentLang: this.props.currentLang, currentLangFullName: currentLangName });
		}
	}

	componentWillUnmount = () => window.removeEventListener('resize', this.handleResize);

	render() {
		if (!this.props.show) {
			return null;
		}
		
		return (
			<div className='informative-modal'>
					<div className={this.informativeModalLeftSideClassGenerator()}>
						<div className='leftSideConatiner'>
							<div className='leftSideConatiner__container'>
								{jsondata.elementTypes.main.map(type => {
									if (type === 'mainBanner') {
										return (
											<div key={type} className='leftSideConatiner_rectangle banner'>
												<p>{getTranslation(typeTranslations[type])}</p>
												<div className='banner_containerImg'>
													<img src={img1} alt=""></img>
												</div>
											</div>
										);
									}
									return (
										<div key={type} className='leftSideConatiner_rectangle'>
											<p>{getTranslation(typeTranslations[type])}</p>
										</div>
									);
								})}
							</div>
							<div className='leftSideConatiner__language'>
								<img
									className="leftSideConatiner__language-lang"
									src={`./img/icons/flags/${this.state.currentLang}.png`}
									alt={this.state.currentLang}
								></img>
								<div className="leftSideConatiner__language-content">
									<p>{this.state.currentLangFullName}</p>
									<img
										src="./img/icons/arrows/keyboard-arrow-down.svg"
										alt=""
										className="leftSideConatiner__language-content-icon"
									></img>
								</div>
							</div>
						</div>
						<div className='bannerFog'></div>
					</div>
					<img className='imgCloudFirst' src={insNonActive} alt={""}></img>
					{this.state.showFirstCloud && (
						<div className={this.informativeModalFirstCloudClassGenerator()}>
							<button className='closeBtn' onClick={this.handleCloseBtn}>
								<svg
									width='20'
									height='20'
									viewBox='0 0 24 24'
									xmlns='http://www.w3.org/2000/svg'>
									<path
										d='M18.69 5.321a1.057 1.057 0 0 0-1.498 0L12 10.503 6.808 5.31A1.057 1.057 0 1 0 5.31 6.808L10.503 12 5.31 17.192a1.057 1.057 0 1 0 1.497 1.497L12 13.497l5.192 5.192a1.057 1.057 0 1 0 1.497-1.497L13.497 12l5.192-5.192a1.064 1.064 0 0 0 0-1.487z'
										fillRule='evenodd'
									/>
								</svg>
							</button>
							<div className='informative-modal__cloud-textSection'>
								<p className='titleInstruction'>
									{getTranslation("cloudFirstText1")}
								</p>
								<p className='textInstruction1 textInstruction1__cloudFirst'>
									{getTranslation("cloudFirstText2")}
								</p>
								<p className='textInstruction2 textInstruction2__cloudFirst'>
									{getTranslation("cloudFirstText3")}
								</p>
							</div>
							<div className='informative-modal__cloud-bottomSection'>
								<p className='stepCount'>{getTranslation("instructionCounter1")}</p>
								<button
									className='nextInstructionBtn'
									onClick={() => this.setState({ showFirstCloud: false, showSecondCloud: true })}>
									{getTranslation("nextInstruction")}
								</button>
							</div>
						</div>
					)}
					{/* druga chmura */}
					<img className={this.informativeModalSecondImgCloudClassGenerator()} src={insActive} alt={""}></img>
					{this.state.showSecondCloud && (
						<div className='informative-modal__cloud informative-modal__cloudSecond'>
							<button className='closeBtn' onClick={this.handleCloseBtn}>
								<svg
									width='20'
									height='20'
									viewBox='0 0 24 24'
									xmlns='http://www.w3.org/2000/svg'>
									<path
										d='M18.69 5.321a1.057 1.057 0 0 0-1.498 0L12 10.503 6.808 5.31A1.057 1.057 0 1 0 5.31 6.808L10.503 12 5.31 17.192a1.057 1.057 0 1 0 1.497 1.497L12 13.497l5.192 5.192a1.057 1.057 0 1 0 1.497-1.497L13.497 12l5.192-5.192a1.064 1.064 0 0 0 0-1.487z'
										fillRule='evenodd'
									/>
								</svg>
							</button>
							<div className='informative-modal__cloud-textSection'>
								<p className='titleInstruction'>
									{getTranslation("cloudSecondText1")}
								</p>
								<p className='textInstruction1'>
									{getTranslation("cloudSecondText2")}
								</p>
								<p className='textInstruction2 textInstruction2__cloundSecond'>
									{getTranslation("cloudSecondText3")}
								</p>
							</div>
							<div className='informative-modal__cloud-bottomSection'>
								<p className='stepCount'>{getTranslation("instructionCounter2")}</p>
								<div className='btnContainer'>
									<button
										className='backInstructionBtn'
										onClick={() => this.setState({ showFirstCloud: true, showSecondCloud: false })}>
										{getTranslation("returnInstruction")}
									</button>
									<button
										className='nextInstructionBtn '
										onClick={() => this.setState({ showSecondCloud: false, showThirdCloud: true },
										() => {
											const generateBtn = document.querySelector(".generate-btn");
											generateBtn.style.zIndex = "99999";
											const navbar = document.querySelector(".navbar");
											const generateBtnBlocker = document.createElement("div");
											generateBtnBlocker.classList.add("generateBtnBlockerClass");
											navbar.appendChild(generateBtnBlocker);
										})}>
										{getTranslation("nextInstruction")}
									</button>
								</div>
							</div>
						</div>
					)}
					{/* trzecia chmura */}
					{this.state.showThirdCloud && (
						<div className='informative-modal__cloud informative-modal__cloudThird'>
							<button className='closeBtn' onClick={this.handleCloseBtn}>
								<svg
									width='20'
									height='20'
									viewBox='0 0 24 24'
									xmlns='http://www.w3.org/2000/svg'>
									<path
										d='M18.69 5.321a1.057 1.057 0 0 0-1.498 0L12 10.503 6.808 5.31A1.057 1.057 0 1 0 5.31 6.808L10.503 12 5.31 17.192a1.057 1.057 0 1 0 1.497 1.497L12 13.497l5.192 5.192a1.057 1.057 0 1 0 1.497-1.497L13.497 12l5.192-5.192a1.064 1.064 0 0 0 0-1.487z'
										fillRule='evenodd'
									/>
								</svg>
							</button>
							<div className='informative-modal__cloud-textSection'>
								<p className='titleInstruction'>
									{getTranslation("cloudThirdText1")}
								</p>
								<p className='textInstruction1'>
									{getTranslation("cloudThirdText2")}
								</p>
								<p className='textInstruction2 textInstruction2__cloundThird'>
									{getTranslation("cloudThirdText3")}
								</p>
							</div>
							<div className='informative-modal__cloud-bottomSection'>
								<p className='stepCount'>{getTranslation("instructionCounter3")}</p>
								<div className='btnContainer'>
									<button
										className='backInstructionBtn'
										onClick={() => this.setState({ showSecondCloud: true, showThirdCloud: false },
										() => {
											const generateBtn = document.querySelector(".generate-btn");
											generateBtn.style.zIndex = "0";
											const blocker = document.querySelector(".generateBtnBlockerClass");
											blocker.remove();
										})}>
										{getTranslation("returnInstruction")}
									</button>
									<button className='nextInstructionBtn ' onClick={this.handleCloseBtn}>
										{getTranslation("lastInstruction")}
									</button>
								</div>
							</div>
						</div>
					)}
		
					{/* <button onClick={this.handleCloseBtn} className='informative-modal__accept'>
						{getTranslation("OK")}
					</button> */}
			</div>
		);
	}
}

export default InformativeModal
